var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Db } from '../index';
import { CollectionReference } from './collection';
import { ERRORS } from '../const/code';
var START = 'database.startTransaction';
var COMMIT = 'database.commitTransaction';
var ABORT = 'database.abortTransaction';
var Transaction = (function () {
    function Transaction(db) {
        this._db = db;
        this._request = new Db.reqClass(this._db.config);
        this.aborted = false;
        this.commited = false;
        this.inited = false;
    }
    Transaction.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._request.send(START)];
                    case 1:
                        res = _a.sent();
                        if (res.code) {
                            throw res;
                        }
                        this.inited = true;
                        this._id = res.transactionId;
                        return [2];
                }
            });
        });
    };
    Transaction.prototype.collection = function (collName) {
        if (!collName) {
            throw new Error('Collection name is required');
        }
        return new CollectionReference(this, collName);
    };
    Transaction.prototype.getTransactionId = function () {
        return this._id;
    };
    Transaction.prototype.getRequestMethod = function () {
        return this._request;
    };
    Transaction.prototype.commit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var param, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        param = {
                            transactionId: this._id
                        };
                        return [4, this._request.send(COMMIT, param)];
                    case 1:
                        res = _a.sent();
                        if (res.code)
                            throw res;
                        this.commited = true;
                        return [2, res];
                }
            });
        });
    };
    Transaction.prototype.rollback = function (customRollbackRes) {
        return __awaiter(this, void 0, void 0, function () {
            var param, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        param = {
                            transactionId: this._id
                        };
                        return [4, this._request.send(ABORT, param)];
                    case 1:
                        res = _a.sent();
                        if (res.code)
                            throw res;
                        this.aborted = true;
                        this.abortReason = customRollbackRes;
                        return [2, res];
                }
            });
        });
    };
    return Transaction;
}());
export { Transaction };
export function startTransaction() {
    return __awaiter(this, void 0, void 0, function () {
        var transaction;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    transaction = new Transaction(this);
                    return [4, transaction.init()];
                case 1:
                    _a.sent();
                    return [2, transaction];
            }
        });
    });
}
export function runTransaction(callback, times) {
    if (times === void 0) { times = 3; }
    return __awaiter(this, void 0, void 0, function () {
        var transaction, callbackRes, error_1, throwWithRollback;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 10]);
                    transaction = new Transaction(this);
                    return [4, transaction.init()];
                case 1:
                    _a.sent();
                    return [4, callback(transaction)];
                case 2:
                    callbackRes = _a.sent();
                    if (transaction.aborted === true) {
                        throw transaction.abortReason;
                    }
                    return [4, transaction.commit()];
                case 3:
                    _a.sent();
                    return [2, callbackRes];
                case 4:
                    error_1 = _a.sent();
                    if (transaction.inited === false) {
                        throw error_1;
                    }
                    throwWithRollback = function (error) { return __awaiter(_this, void 0, void 0, function () {
                        var err_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(!transaction.aborted && !transaction.commited)) return [3, 5];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4, transaction.rollback()];
                                case 2:
                                    _a.sent();
                                    return [3, 4];
                                case 3:
                                    err_1 = _a.sent();
                                    return [3, 4];
                                case 4: throw error;
                                case 5:
                                    if (transaction.aborted === true) {
                                        throw transaction.abortReason;
                                    }
                                    throw error;
                            }
                        });
                    }); };
                    if (!(times <= 0)) return [3, 6];
                    return [4, throwWithRollback(error_1)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    if (!(error_1 && error_1.code === ERRORS.DATABASE_TRANSACTION_CONFLICT.code)) return [3, 8];
                    return [4, runTransaction.bind(this)(callback, --times)];
                case 7: return [2, _a.sent()];
                case 8: return [4, throwWithRollback(error_1)];
                case 9:
                    _a.sent();
                    return [3, 10];
                case 10: return [2];
            }
        });
    });
}
